import { EAnalyticMode } from '~/modules/analytics/types';

export const DEFAULT_ANALYTIC_MODE = EAnalyticMode.ALL_SESSION;
